import CityPageTemplate from './CityPageTemplate';

export default function OviedoPage() {
  return (
    <CityPageTemplate
      city="Oviedo"
      county="Seminole"
      slug="oviedo"
      zipCodes={['32765', '32766']}
      neighborhoods={['Oviedo on the Park', 'Twin Rivers', 'Alafaya Woods', 'Riverside', 'Carillon']}
      localContext="Oviedo blends small-town charm with growing suburban communities near UCF. From Oviedo on the Park to Alafaya Woods, we serve every neighborhood with care."
      metaDescription="Professional residential and commercial cleaning services in Oviedo, FL. Serving ZIP codes 32765 & 32766. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
